import * as Yup from "yup";

export default Yup.object().shape({
  volume: Yup.number().required("Required"),
  dateOfUplift: Yup.string().required("Required"),
  registry: Yup.string().required("Required")
});
